export default __webpack_public_path__ + "static/media/video_polygon_after.0522781d.mp4";